import { Directive, ElementRef, Optional,  } from '@angular/core';
import { NgControl} from '@angular/forms'

@Directive({
  selector: '[focusOnError]'
})
export class FocusOnErrorDirective  {
  
  public get invalid()
  {
    return this.control.invalid;
  }
  public focus()
  {
    var ins = this
    window.setTimeout(function () { 
      ins.el.nativeElement.focus()
  }, 0); 

  }
  constructor(@Optional() private control: NgControl,  private el: ElementRef) {  }
}
